import P from 'bluebird';
import get from 'lodash/get';
import * as htmlSitemapPostPageActions from '../../action_creators/html_sitemap/html_sitemap_post_page_action_creators';
import log from '../../../services/logger_service';

import asyncHtmlSitemapPostActions from './async_html_sitemap_post_actions';
import asyncRecircFeedActions from '../async_recirc_feed_actions';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';

export default function htmlSitemapPostDetail(params, store) {
  return function firstDispatchHtmlSitemapPost(dispatch) {
    dispatch(htmlSitemapPostPageActions.htmlSitemapPostPageLoading());
    return P.all([
      asyncHtmlSitemapPostActions(params, store)(dispatch),
      asyncRecircFeedActions(params, store)(dispatch)
    ])
      .then(function htmlSitemapPostDetailData() {
        dispatch(
          htmlSitemapPostPageActions.htmlSitemapPostPageLoaded({}, store)
        );
        return true;
      })
      .catch(function handlehtmlSitemapPostError(err) {
        const status = get(err, 'response.status') || 500;
        if (status === 404) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        } else {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
        }
        dispatch(
          htmlSitemapPostPageActions.htmlSitemapPostPageLoadError(err, store)
        );
        return log.error(
          err,
          `Error in html sitemap post page actions, message: ${err.message}`
        );
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/html_sitemap/async_html_sitemap_post_page_actions.js